/**
 * Actie object to check. This is needed by the BarActieAllowedGuard.
 */
export class BarActieFromContext {
    constructor(actie?: BarActieFromContext) {
        if (actie != null) {
            this.actie = actie.actie;
            this.includeVoorwie =
                actie.includeVoorwie === undefined
                    ? true
                    : actie.includeVoorwie;
            this.includeHoedanigheid =
                actie.includeHoedanigheid === undefined
                    ? true
                    : actie.includeHoedanigheid;
        }
    }

    actie: string;
    includeVoorwie?: boolean = true;
    includeHoedanigheid?: boolean = true;
}
